import store from '../reducers/storeRegistration';
import reportActionCreators from '../actions/reportActionCreators';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  const uuid = await evaluateSource(source.uuid, content, parentContentPath, transientContext, nativeFunctions);
  const statusIdentifier = await evaluateSource(source.statusIdentifier, content, parentContentPath, transientContext, nativeFunctions);
  if (uuid === undefined || statusIdentifier === undefined) {
    return undefined;
  }
  const {
    geolocation
  } = store.getState().login;
  const report = {
    id: uuid
  };
  const info = {};
  if (source.note !== undefined) {
    const note = await evaluateSource(source.note, content, parentContentPath, transientContext, nativeFunctions);
    info.note = note;
  }
  const result = await store.dispatch(reportActionCreators.serverSaveStatusUpdates([report], statusIdentifier, {}, geolocation));
  return result;
};
export default {
  evaluate
};